<button *ngIf="collapse" class="btn" type="button" (click)="collapse=false"><i class="fa fa-chevron-circle-down" aria-hidden="true"></i>
     {{'components.dropdownButton.plus' | translate}}
</button>
<button *ngIf="!collapse" class="btn" type="button" (click)="collapse=true"><i class="fa fa-chevron-circle-up" aria-hidden="true"></i> 
     {{'components.dropdownButton.minus' | translate}}
</button>